import Log from '@/classes/debug/Log'
import commentApi from '@/api/comment/commentApi'
import FormData from '@/classes/form/FormData'
import FormDescriptor from '@/classes/form/FormDescriptor'
import AuthUser from '@/classes/auth/AuthUser'
import { Comment } from '@/classes/case/Comment'
import { InvalidDataError } from '@/classes/errors'

const state = {
  comments: [],
  commentFormDatas: [],
  commentFormDescriptors: []
}

const mutations = {
  setStateComments: (state, comments) => {
    state.comments = comments
  },
  setCommentFormDescriptors: (state, data) => {
    state.commentFormDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setCommentFormDatas: (state, data) => {
    state.commentFormDatas = FormData.initiateFormDatas(state.commentFormDescriptors)
    FormData.loadInitialFormDatas(data, state.commentFormDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.commentFormDescriptors, state.commentFormDatas)
  }
}

const actions = {
  getComments ({ commit }, requestData) {
    let filter = requestData.reviewResultId ? `/${requestData.reviewResultId}` : `?case=${requestData.caseId}`
    return commentApi.getComments(filter).then((response) => {
      try {
        commit('setStateComments', Comment.asComments(response.data))
      } catch (err) {
        throw new InvalidDataError('Invalid data when getting Comments.')
      }
    }).catch((err) => {
      throw err
    })
  },
  setupCommentForm ({ commit }, reviewResultId) {
    return commentApi.getCommentForm(reviewResultId).then((response) => {
      let formData = response.data.form_data ? [response.data.form_data] : []
      commit('setCommentFormDescriptors', [response.data])
      commit('setCommentFormDatas', formData)
    }).catch((err) => {
      throw err
    })
  },
  createCommentForm ({ commit }, requestData) {
    return commentApi.postCommentForm(requestData.data.reviewResultId, requestData.serializedData).then((response) => {
      Log.debug('Posted Form Data for Comment Form ' + requestData.serializedData + ' as ' + AuthUser.getProfileTypeVerbose())
      return response
    }).catch((err) => {
      throw err
    })
  },
  updateCommentForm ({ commit }, requestData) {
    return commentApi.patchCommentForm(requestData.data.reviewResultId, requestData.serializedData).then((response) => {
      Log.debug('Patched Form Data for Comment Form ' + requestData.serializedData + ' as ' + AuthUser.getProfileTypeVerbose())
      return response
    }).catch((err) => {
      throw err
    })
  },
  deleteComment ({ commit }, commentId) {
    return commentApi.deleteComment(commentId).then((response) => {
      return true
    }).catch((err) => {
      throw err
    })
  }
}

export default {
  state,
  mutations,
  actions
}
